import { combineReducers } from "redux";
import { sockets } from "./sockets";


// import reducers
export default combineReducers({
	// reducers
	sockets
});